import { CONSTANTS } from "@/constants";
import { mergeAPIError } from "@/utils/errors";
import { request } from "@/utils/request";
import useSWR from "swr";


export interface CampaignActive {
    campaignCode: string;
    name: string;
    tag: string[];
    image: string;
    commonEggAmount: number;
    rareEggAmount: number;
    epicEggAmount: number;
    tokenAddress: string;
    tokenAmount: number;
    totalParticipant: number;
    maxParticipant: number;
    startTime: string;
    endTime: string;
    status: 'end' | 'upcoming' | 'active';
    eggType: 'COMMON' | 'RARE' | 'MYTHIC';
    eggAmount: number;
    contractAddress: string;
    id: number;
    description: null | string;
    spainDescription: null | string;
    i18nDesc: any;
}

export interface ResponseCampaignActive {
    success: boolean;
    message: string;
    code: string;
    innerMessage?: string | null;
    data: CampaignActive[];
}

async function fetchCampaignActive(url: string) {
    const response = await request(url);

    if (!response.ok) {
        const msg = await response
            .json()
            .then((e) => mergeAPIError(e))
            .catch((e) => e.message ?? response.statusText);
        throw new Error(`Failed with status ${response.status} :${msg}`);
    }

    const data = (await response.json()) as ResponseCampaignActive;

    return data
}

export function useCampaign() {

    return useSWR(`${CONSTANTS.CAMPAIGN_URL}/api/campaign/active`, (url: string) => fetchCampaignActive(url), {
        dedupingInterval: 10000,
        errorRetryCount: 3
    });
}